<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <ng-container *ngFor="let policy of policyDetails">
    <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
      <mapfre-card
        [singleCard]="false"
        [additionalClasses]="
          'policy-details documents details documents-w-858 ' + policy?.policyType
        "
      >
        <ng-container *ngIf="policy?.policyType === 'AUTO' || policy?.policyType === 'COMMERCIAL_AUTO'">
          <app-car-header [policy]="policy"></app-car-header>
        </ng-container>
        <ng-container *ngIf="policy?.policyType === 'HOME'">
          <app-home-header [policy]="policy"></app-home-header>
        </ng-container>
        <ng-container
          *ngIf="policy?.policyType !== 'HOME' && policy?.policyType !== 'AUTO' && policy?.policyType !== 'COMMERCIAL_AUTO'"
        >
          <app-all-header [policy]="policy"></app-all-header>
        </ng-container>

        <app-dashboard-nav [policyId]="policyId" [policyType] = "policy?.policyType"></app-dashboard-nav>

        <ng-container *ngIf="loadingDocuments">
          <mapfre-loading></mapfre-loading>
        </ng-container>

        <ng-container *ngIf="isAvailable; else showApp">
          <div class="text-center">
          <div class="maintenance-sorry-page-document">
            <div class="text-center">
            <div class="head margin-bottom mb24">
                {{ 'MAINTENANCE_DOCUMENT' | translate}}
            </div>
          </div>
            <div class="inprogress margin-bottom mb24">
                {{ 'MAINTENANCE_INPROGRESS_1' | translate}}
                <div>
                {{ 'MAINTENANCE_INPROGRESS_2' | translate}}                                    
                </div>
            </div>
          
            <div class="inprogress margin-bottom mb24">
                <b>{{ 'MAINTENANCE_TIME' | translate}}</b>
            </div>
          
          </div>
        </div>
        </ng-container>

        <ng-template #showApp>
        <ng-container *ngIf="!loadingDocuments">          
          <ng-container *ngIf="initialDocumentsData?.length !== 0">
            <section
              class="documents-content table-container details-content margin-top mt32 mobile-margins old-billing-table-width"  [ngClass]="{'ma-documents':!isAcmic}"
            >           
            <div *ngIf="isAcmic && policy?.policyStatus === 'ACTIVE' && policy?.policyType === 'AUTO'">
              <ng-container *ngIf="isMultiVehEligibleForIdCard(policy?.vehicle)?.length <= 1; else multipleVehicles">
                <div class="id-cards-title">
                  {{'ID Card'}}
              </div>
              <div class="id-cards-desc">
                {{'Proof of insurance ID Cards will display the policyholders and the vehicle listed on the policy.'}}
              </div>
              <div class="id-card-actions mt-4">
                <mapfre-button          
                  [additionalClasses]="'view-id-card'"
                  (click)="getIdCardDocument(isMultiVehEligibleForIdCard(policy?.vehicle), 'view', policy)"> {{"View" | translate}}
                </mapfre-button>
                <mapfre-button                      
                  [additionalClasses]="'download-btn'"
                  (click)="getIdCardDocument(isMultiVehEligibleForIdCard(policy?.vehicle), 'download', policy)"> {{ "DOWNLOAD" | translate}}
                </mapfre-button>
              </div>
              </ng-container>
              <ng-template #multipleVehicles>
                <div class="id-cards-title">
                    {{'ID Cards'}}
                </div>
                <div class="id-cards-desc">
                  {{'Select your vehicle(s) to view or download proof of insurance ID Cards. ID Cards will display the policyholders and the vehicle(s) selected.'}}
                </div>
                <app-id-cards [isPolicyExists]="true" [policyId]="policyId" [policies]="activePolicies"></app-id-cards>
              </ng-template>              
            </div> 
              <table class="documents-table table"
              [ngClass]="isAcmic ? 'custom-document-table table-striped-acmic' : 'custom-document-table table-striped table-striped-ma'"
              >
                <thead>
                  <th
                  *ngIf="company === 'ACIC' || company === 'TW'"
                  class="row no-padding title-th">
                    <h4 class="col no-padding" [ngClass]="isAcmic ? 'fs-document no-margin-bottom' : 'dm-sans-medium no-margin brand-blue-secondary'">{{ filterName }}</h4>
                  </th>
                  <th
                    *ngIf="policy?.policynumber.policyNumber.length === 10"
                    class="row no-padding title-th document-title-pd"
                    >
                    <h4 class="col no-padding" [ngClass]="isAcmic ? 'fs-document no-margin-bottom' : 'dm-sans-medium no-margin brand-blue-secondary document-tite-mt'">{{ filterName }}</h4>
                    
                    <div class="col-auto no-padding ">
                      <div
                        class="dropdown"
                        style="position: relative !important;"
                        [ngClass]="{ 'dropdown-doc-acmic': isAcmic }"
                        mdbDropdown
                        (dropdownShow)="setFilterIcon(true)"
                        (dropdownHidden)="setFilterIcon(false)"
                      >
                        
                        <ng-container *ngIf="isAcmic; else maFilterIcon">
                          <button
                          mdbDropdownToggle
                          type="button"
                          class="btn dropdown-toggle no-box-shadow no-padding-right filter-dropdown-btn"
                        >
                       
                          <img src="assets/img/images/acmic-icon-filter.svg" class="margin-right mr4" alt="filter icon" />
                          Filters
                          <span class="filter-icon">
                            <img src="assets/img/images/icon-simple-arrow-down.svg" class="margin-left ml4" alt="filter up and down icon" />
                        </span>
                        </button>
                        </ng-container>
                        <ng-template #maFilterIcon>
                          <button
                          mdbDropdownToggle
                          type="button"
                          class="btn dropdown-toggle no-box-shadow dropdown-for-documents no-padding-bottom no-padding-left no-padding-right no-padding-top"
                        >
                          <img src="assets/img/images/icon-filter.svg" class="margin-right mr4" alt="filter icon" />
                          Filters
                          <span class="filter-icon">
                              <img [src]="filterUpAndDownIcon" class="margin-left ml4" alt="filter up and down icon" />
                          </span>
                        </button>
                        </ng-template>                          

                        <div
                          class="dropdown-menu document-dpdw"
                          [ngClass]="{
                            'document-dpdw-acmic': isAcmic,
                            'document-dpdw-non-acmic': !isAcmic
                          }"
                          mdbDropdownMenu
                        >
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              [ngClass]="{ active: filterType === '' }"
                              (click)="onSelectFilter('all-doc')"
                            ><span class="material-icons">check</span> All Documents</button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              [ngClass]="{ active: filterType === 'PC' }"
                              (click)="onSelectFilter('pol')"
                            ><span class="material-icons">check</span> Policy</button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              [ngClass]="{ active: filterType === 'BC' }"
                              (click)="onSelectFilter('bill')"
                            ><span class="material-icons">check</span> Billing</button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              [ngClass]="{ active: filterType === 'RENEWAL' }"
                              (click)="onSelectFilter('renew')"
                            ><span class="material-icons">check</span> Renewal</button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              [ngClass]="{ active: filterType === 'ENDORSE' }"
                              (click)="onSelectFilter('end')"
                            ><span class="material-icons">check</span> Endorsements</button>
                          </li>
                        </div>
                      </div>
                    </div>
                  </th>
                  <hr class="ma-hr-tag update-hr margin-bottom mrbt24" [ngClass]="{ 'no-margin-top': isAcmic }"/>
                  <th
                    *ngIf="false"
                    class="row mapfre-card-download-button"
                    colspan="4"
                  >
                    <div class="col no-padding-left">
                      <img
                        src="/assets/img/images/mapfre-card-logo-color.png"
                        width="177"
                        alt="logo card"
                      />
                    </div>
                    <div class="col-auto no-padding">
                      <app-onboarding-wallet-modal
                        [policyNumber]="policyId"
                      ></app-onboarding-wallet-modal>
                    </div>
                  </th>

                  <div class="upload-in-documents" *ngIf="isEligibleForUpload || isAcmic">
                    <div class="send-us-doc">{{'Need to send us a document?'}}</div>
                    <div [ngClass]="{'old-billing-upload': !isAcmic}"><app-upload-type-modal [policy]="policy"></app-upload-type-modal></div>
                  </div>
                </thead>
                <tbody>
                  <tr
                    class="row row-content"
                    *ngIf="
                      policy?.policyFlags?.isEbill === 'ENROLLED' &&
                      policy?.policynumber?.policyNumber.length === 6
                    "
                    (click)="viewEBILL()"
                  >
                    <td
                      class="col-auto col-type text-center padding-left pl16"
                      scope="row"
                    >
                    </td>
                    <td class="col col-name no-padding-left">
                      {{ "eBILL" }}
                      <span class="legal disclaimer small font-color">{{
                        "View your bills online"
                      }}</span>
                    </td>
                    <td class="col-auto col-view text-center view-padding">
                      <div class="documents-view-col cursor-pointer">
                        <span class="align-top view-copy">{{
                          "ACCESS" | translate
                        }}
                        <i class="material-icons align-top"
                          >keyboard_arrow_right</i
                        >
                      </span>
                        
                      </div>
                    </td>
                  </tr>
                  <ng-container *ngIf="documentsData?.length > 0">
                  
                  <ng-container>
                    <tr class="row row-content">
                      <th class="document-table-col-1" [ngClass]="{ 'dm-sans-medium': !isAcmic }">
                        <span class="acmic-date-col">
                          {{ 'Date' | translate }}
                          <img [src]="upAndDownIconForDocDate" class="cursor-pointer vertical-align-bottom" (click)="toggleAndsortDocumentsByDate()" alt="arrow"/>
                        </span>
                      </th>
                      <th class="document-table-col-2" [ngClass]="{ 'dm-sans-medium': !isAcmic }">
                          {{ 'Document name' | translate }}
                          <img [src]="upAndDownIconForDocName" class="cursor-pointer vertical-align-bottom"  (click)="toggleAndsortDocumentsByName()" alt="arrow" />
                      </th>
                      <th class="document-table-col-3 hide-in-mobile"> 
                          
                      </th>
                      <th class="document-table-col-4 hide-in-mobile">
                          
                      </th>
                    </tr>
                    <tr
                      class="row row-content"
                      *ngFor="
                        let doc of documentsData;
                        index as i
                      "
                      [hidden]="policy.hasAffinityGroup && doc.type === 'AUTOPAY'"                   
                    >
                      <ng-container *ngIf="!isAcmic; else acmicDocData">
                        <td class="document-table-col-1">
                          {{ doc.transactionDate | date: "MM/dd/yyyy" }}
                        </td>
                        <ng-container *ngIf="doc?.fileName; else docDescription" >
                          <td [attr.title]="doc.fileName" class="document-table-col-2 ellipsed-td">
                            {{ doc.fileName }}
                          </td>
                        </ng-container>
                        <ng-template #docDescription>
                          <td class="document-table-col-2">
                            {{ doc.description }}
                          </td>
                        </ng-template>
                        
                    </ng-container>
                    <ng-template #acmicDocData>
                      <td class="document-table-col-1">
                        <!-- <div class="acmic-doc-type">Date</div> -->
                        <div class="acmic-doc-val acmic-doc-val-1">{{ doc.transactionDate | date: "MM/dd/yy" }}</div>
                      </td>
                      <td [attr.title]="doc.fileName" class="document-table-col-2 ellipsed-td">
                        <div class="acmic-doc-val">{{ doc.fileName }}</div>
                      </td>
                    </ng-template>
                      <td class="document-table-col-3">
                        <span (click)="onViewDocument( doc.documentId,
                                                policy?.policynumber.policyNumber,
                                                doc.type,
                                                doc.transactionDate,
                                                doc.description,
                                                i+1
                                              )
                                            ">
                          <span class="doc-action-txt dm-sans-medium cursor-pointer ele-custom-loader view-doc-action-{{i+1}}">{{ "View" | translate }}
                          </span>
                          <ng-container *ngIf="isAcmic; else maViewIcon">
                            <img src="assets/img/images/icon-view-blue.svg" class="cursor-pointer ele-custom-loader view-doc-action-{{i+1}}" alt="view icon" />
                          </ng-container>
                          <ng-template #maViewIcon>
                            <img src="assets/img/images/icon-view.svg" class="cursor-pointer ele-custom-loader view-doc-action-{{i+1}}" alt="view icon" />
                          </ng-template>
                          
                        </span>
                      </td>
                      <td class="document-table-col-4">
                        <span (click)="
                                                onDownloadDocument(
                                                doc.documentId,
                                                policy?.policynumber.policyNumber,
                                                doc.type,
                                                doc.transactionDate,
                                                i+1
                                              )
                                            ">
                          <span class="dm-sans-medium doc-action-txt cursor-pointer ele-custom-loader download-doc-action-{{i+1}}">{{
                            "Download" | translate
                            }} </span>
                            <ng-container *ngIf="isAcmic; else maDownloadIcon">
                              <img src="assets/img/images/icon-download-acmic-blue.svg" class="cursor-pointer ele-custom-loader download-doc-action-{{i+1}}" alt="download icon" />
                            </ng-container>
                            <ng-template #maDownloadIcon>
                              <img src="assets/img/images/icon-download-red.svg" class="cursor-pointer ele-custom-loader download-doc-action-{{i+1}}" alt="download icon" />
                            </ng-template>
                        </span>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                </tbody>
              </table>
            
            </section>
          </ng-container>
          <ng-container *ngIf="documentsData?.length === 0">
            <section class="details-content documents-content no-documents">
              <div class="no-documents-container">
                <ng-container *ngIf="false">
                  <div class="row mapfre-card-download-button">
                    <div class="col col-left">
                      <img
                        src="/assets/img/images/mapfre-card-logo-color.png"
                        width="177"
                        alt="card logo"
                      />
                    </div>
                    <div class="col col-right">
                    </div>
                  </div>
                </ng-container>
                <div class="row">
                  <div class="col">
                    <img src="./assets/img/images/no-documents.png" alt="no documents" />
                    <h1 class="title margin-vertical mv16">
                      {{ "NO_DOCUMENTS_TITLE" | translate }}
                    </h1>
                    <p>{{ "NO_DOCUMENTS_PARAGRAPH" | translate }}</p>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>
        </ng-container>
        <section class="row legal-links" [ngClass]="{'ma-legal-links margin-top mt24':!isAcmic}">
          <div class="col-12 col-md text-right">
            <ng-container *ngIf="isAcmic; else MAstate">
              <ng-container *ngIf="policy?.jurisdiction.state ==='WA'; else IDstate">
                  <a
                  [hidden]="policy?.policyType !== 'AUTO'"
                  class="mapfre link normal-link blue-link underline MAIP-link"
                  href="./assets/docs/AC001-AMWA-02-23-WA-ACMIC.pdf"
                  target="_blank"
                  rel="noopener"
                  >
                  {{ "AUTO_INSURANCE_POLICY" | translate }} 
                </a>
              </ng-container>
              <ng-template #IDstate>
                <a
                [hidden]="policy?.policyType !== 'AUTO'"
                class="mapfre link normal-link blue-link underline MAIP-link"
                href="./assets/docs/AC001-AMID-02-23-ID-ACMIC.pdf"
                target="_blank"
                rel="noopener"
                >
                {{ "AUTO_INSURANCE_POLICY" | translate }} 
              </a>
            </ng-template>
            </ng-container>
            <ng-template #MAstate>
                <a
                [hidden]="policy?.policyType !== 'AUTO'"
                class="mapfre link normal-link red-link underline MAIP-link"
                href="./assets/public/docs/MA%20AUTO%20POLICY%202016.pdf#zoom=100"
                target="_blank"
                rel="noopener"
                [ngClass]="{'fs-16':!isAcmic}"
                *ngIf="company !== 'ACIC' && company !== 'TW'">
                {{ "MA_AUTO_INSURANCE_POLICY" | translate }}
              </a>
            </ng-template>
            </div>
          <div class="col-12 col-md-auto text-right" *ngIf="!isAcmic">
            <a
              class="mapfre link normal-link red-link underline fs-16"
              href="https://www.mass.gov/files/documents/2016/07/rk/ways-to-save.pdf#zoom=100"
              target="_blank"
              rel="noopener"
              *ngIf="company !== 'ACIC' && company !== 'TW'"
            >
              {{ "WAYS_TO_SAVE" | translate }}
            </a>
          </div>
        </section>
      </ng-template>
      </mapfre-card>
    </ng-container>
  </ng-container>
</ng-container>
